import { useMutation } from '@tanstack/react-query';
import { forgotPassword, signOutUser } from 'shared/services/backend-api';
import { AuthFlowError } from 'shared/types/auth-flow-error';
import { ForgotPasswordErrorTypes } from 'shared/types/forgot-password-form';

export const useForgotPasswordMutation = () =>
  useMutation<void, AuthFlowError<ForgotPasswordErrorTypes>, { email: string }>(
    {
      mutationFn: async ({ email }) => {
        await signOutUser();
        await forgotPassword(email);
      },
    },
  );
